import { dom, library, config } from '@fortawesome/fontawesome-svg-core';


import {
    faExclamation,
    faSearch,
    faPlusCircle,
    faMinusCircle,
    faRedo,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faCheck,
    faTimes,
    faInfoCircle,
    faExclamationCircle,
    faClock,
    faMapMarkerAlt,
    faPlay,
} from '@fortawesome/pro-regular-svg-icons';

import {
    faPlus,
    faAngleRight,
    faAngleLeft,
    faAngleDown,
    faAngleUp,
    faComments,
    faEnvelope,
    faExpandWide,
    faSearch as falSearch,
    faArrowRight,
} from '@fortawesome/pro-light-svg-icons';

config.autoReplaceSvg = true;
config.observeMutations = true;
// config.searchPseudoElements = true;

library.add(
    faCheck,
    faTimes,
    faInfoCircle,
    faExclamationCircle,
    faPlus,
    faAngleRight,
    faSearch,
    faComments,
    faEnvelope,
    faAngleLeft,
    faClock,
    faMapMarkerAlt,
    faExpandWide,
    faAngleDown,
    faAngleUp,
    faPlusCircle,
    faMinusCircle,
    faPlay,
    faRedo,
    falSearch,
    faArrowRight,
);

dom.watch();
